import ServicePage from './ServicePage';
import { Ticket } from 'lucide-react';

const PROVIDERS = [
  { name: 'Tiqets', desc: 'Skip-the-line tickets to museums, attractions, and experiences worldwide. Instant confirmation, flexible booking.', url: 'https://tiqets.tpm.lv/NnUJBB3c', icon: Ticket, color: 'from-orange-500 to-orange-600', tagline: 'Skip the Line' },
  { name: 'GetYourGuide', desc: 'Book tours, activities, and attraction tickets in destinations worldwide. Verified reviews and free cancellation.', url: 'https://www.getyourguide.com', icon: Ticket, color: 'from-red-500 to-red-600', tagline: 'Tours & Activities' },
];

export default function ActivitiesAttractionsPage() {
  return <ServicePage title="Activities & Attractions" subtitle="Discover and book tours, museum tickets, and unforgettable experiences at your destination." icon={Ticket} providers={PROVIDERS} testId="activities-attractions-page" />;
}
